import React, { PropsWithChildren } from 'react';

import { ThemeProvider } from 'styled-components';
import defaultTheme from '../../assets/styled/themes/defaultTheme';

export interface FrameProps extends PropsWithChildren<Record<string, unknown>> {}

function Frame(props: FrameProps) {
  return <ThemeProvider theme={defaultTheme}>{props.children}</ThemeProvider>;
}

export default Frame;
